// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  font-family: 'Avenir';
  font-size: 16px;
  margin-left: 1rem;
}
p > u > strong {
  font-family: 'Avenir';
  color: #051d33;
  font-size: 18px;
  /* margin-left: -1rem; */
}
h1 {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/TOU/styles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,SAAS;AACX","sourcesContent":["p {\n  font-family: 'Avenir';\n  font-size: 16px;\n  margin-left: 1rem;\n}\np > u > strong {\n  font-family: 'Avenir';\n  color: #051d33;\n  font-size: 18px;\n  /* margin-left: -1rem; */\n}\nh1 {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
